import { z } from "zod";

export const applyWfhSchema = z.object({
  start_date: z
    .union([z.date(), z.null()]) // Allow null for the date field
    .refine((val) => val !== null, {
      message: "Start Date is required",
    }),
  end_date: z
    .union([z.date(), z.null()]) // Allow null for the date field
    .refine((val) => val !== null, {
      message: "End Date is required",
    }),
  wfh_type: z
    .string({
      required_error: "Wfh type is required",
      invalid_type_error: "Wfh type must be a string",
    })
    .nonempty("Wfh type is required")
    .refine(
      (value) => ["FD", "HDF", "HDS"].includes(value),
      "Invalid Wfh type"
    ),
  reason: z
    .string({
      required_error: "Reason is required",
      invalid_type_error: "Reason must be a string",
    })
    .trim()
    .nonempty("Reason is required"),
});
